import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { setNotice } from '../../redux/noticesSlice';
import { ENoticeType } from 'src/enums';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const id = String(new Date().getTime());
    const isRead = false;

    if (action.payload.data.statusCode !== 403) {
      api.dispatch(
        setNotice({
          ...action.payload.data,
          type: ENoticeType.error,
          id,
          isRead,
          ...(action.payload.data.statusCode === 404 && {
            timestamp: new Date().toISOString(),
            message: `Не найден адрес: ${action.payload.data?.message.split(' ')?.[2]}`,
          }),
          ...(action.payload.data.message === 'code.still.active' && {
            timestamp: new Date().toISOString(),
            message: `Предыдущий код ещё активен`,
          }),
        }),
      );
    }
  }

  return next(action);
};
